import { Component } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { TabViewModule } from 'primeng/tabview';

import { FloatLabelModule } from 'primeng/floatlabel';
import { PasswordModule } from 'primeng/password';
import { InputSwitch, InputSwitchModule } from 'primeng/inputswitch';
import { CalendarModule } from 'primeng/calendar';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { NotificationPreference, Reviewer } from '../../../store/reviewer/reviewer.interface';
import { StorageService } from '../../../shared/services/storage.service';
import { ReviewerService } from '../../../shared/services/reviewer.service';
import { InputMaskModule } from 'primeng/inputmask';
import { HeadingComponent } from '../../../shared/components/heading/heading.component';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule, FormControl } from '@angular/forms';
import { ToastService } from '../../../shared/services/toast.service';
import moment from 'moment';
import { ConfirmationDialogService } from '../../../shared/services/confirmation-dialog.service';
import { AuthService } from '../../../shared/services/auth.service';
import { UserService } from '../../../shared/services/user.service';
import { constants } from '../../../shared/constants/constants';
import { ProfileInformationClass } from '../../../shared/components/profile-information/profile-information.component';
import { environment } from '../../../../environments/environment';
import { Router } from '@angular/router';
import { lastValueFrom } from 'rxjs';
import { TooltipModule } from 'primeng/tooltip';
import { HelperService } from '../../../shared/services/helper.service';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { PipesModule } from '../../../shared/pipes/pipes.module';
import { QRCodeModule } from 'angularx-qrcode';
import { DialogModule } from 'primeng/dialog';
import { pwcAppUrls, staftrAppUrls } from '../../../shared/constants/appUrls';
import { ConfigurationService } from '../../../shared/services/configuration.service';

@Component({
  selector: 'app-reviewer-setting',
  standalone: true,
  imports: [CommonModule, InputSwitchModule, ReactiveFormsModule, ButtonModule,
     InputMaskModule, TabViewModule, FloatLabelModule, PasswordModule,
      CalendarModule, InputTextModule, DropdownModule, TooltipModule, PipesModule,
      QRCodeModule, DialogModule],
  templateUrl: './reviewer-setting.component.html',
  styleUrl: './reviewer-setting.component.scss',
  providers:[DatePipe,InputSwitch, DynamicDialogRef]
})
export class ReviewerSettingComponent extends ProfileInformationClass{
  [x: string]: any;
  cities: any[] | undefined;
  reviewer!: Reviewer
  showEditPhoneForm = false;
  editPhoneForm!: FormGroup;
  verificationPhoneForm!: FormGroup;
  notificationSwitches!: FormGroup;
  unAvailableForm!: FormGroup;
  passwordForm!: FormGroup;
  _isShowVerificationPhoneForm = false;
  currentDate = new Date();
  minStartDate = new Date();
  maxStartDate = new Date();
  minEndDate = new Date();
  maxEndDate = new Date();
  phone = { partOne: '', partTwo: '', partThree: '' };
  tempPhone = { partOne: '', partTwo: '', partThree: '' };
  isDateChange = false;
  notificationPref!: NotificationPreference;
  title = environment.title;
  showAppDownloadModal = false;
  isPwcEnabled = false;
  appUrl = '';
  appStoreUrl = staftrAppUrls.iOS;
  playStoreUrl = staftrAppUrls.android;

  constructor(
    private storageService: StorageService,
    private confirmationDialogService: ConfirmationDialogService, 
    private configurationService: ConfigurationService,
    private authService:AuthService,
    helperService: HelperService,
    fb: FormBuilder, 
    reviewerService:ReviewerService, 
    toastService:ToastService, 
    userService: UserService,
    router: Router,
    reviewerDetailRef: DynamicDialogRef,
    dialogService: DialogService,
  ) {
      super(fb, reviewerService, toastService, userService, router, reviewerDetailRef, dialogService, helperService);

      this.currentDate.setDate(this.currentDate.getDate() - 1);
      this.editPhoneForm = this.fb.group({
        partOne: ['', Validators.required],
        partTwo: ['', Validators.required],
        partThree: ['', Validators.required]
      });
      this.verificationPhoneForm = this.fb.group({
        verificationCode: ['', Validators.required]
      });
      this.notificationSwitches = this.fb.group({
        sms: [''],
        email: [''],
        notification: ['']

      });
      this.unAvailableForm = this.fb.group({
        unAvailableStatus:[''],
        startDate:[''],
        endDate:['']
      });
      this.passwordForm = this.fb.group({
        currentPassword: ['', Validators.required],
        newPassword: ['', [Validators.required, Validators.minLength(8)]],
        confirmPassword: ['', Validators.required]
      }, { validators: this.mustMatch('newPassword', 'confirmPassword') });
  }
  
  async ngOnInit() {
    this.initializeSettings();
    await super.init();
  }
  
  mustMatch(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];

      if (matchingControl.errors && !matchingControl.errors['mustMatch']) {
        return;
      }

      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ mustMatch: true });
      } else {
        matchingControl.setErrors(null);
      }
    };
  }
  
  initializeSettings(){
    this.isPwcEnabled = this.configurationService.getPwcFlag();
    if(this.isPwcEnabled){
      this.appStoreUrl = pwcAppUrls.iOS;
      this.playStoreUrl = pwcAppUrls.android;
    }
    lastValueFrom(this.userService.getNotificationPreference());
    lastValueFrom(this.reviewerService.updateProfileStrengthByTenant(this.storageService.getTenant().firm._id,{settings:true}));
    this.reviewerService.fetchReviewer().subscribe((reviewer:Reviewer)=>{
      this.reviewer = reviewer;
      this.notificationSwitches.setValue({
        sms:reviewer.notificationPreference.sms,
        email:reviewer.notificationPreference.email,
        notification:reviewer.notificationPreference.notification 
      });

      if(!reviewer.arn){
        this.notificationSwitches.patchValue({notification: false});
        this.notificationSwitches.get('notification')?.disable();
      }

      const startDate = reviewer.notificationPreference.unAvailableStartDate ? new Date(reviewer.notificationPreference.unAvailableStartDate) : new Date();
      let unAvailableEndDate = new Date(reviewer.notificationPreference.unAvailableEndDate);
      unAvailableEndDate.setHours(0, 0, 0, 0);
      const endDate = reviewer.notificationPreference.unAvailableEndDate ? unAvailableEndDate : new Date(new Date(startDate).setDate(startDate.getDate() + 7));

      this.unAvailableForm.setValue({
        unAvailableStatus:reviewer.notificationPreference.unAvailableStatus,
        startDate: startDate,
        endDate: endDate
      });
  
      this.notificationPref = this.preparePreference(reviewer.notificationPreference);
      this.formatPhoneNo();
      this.setEndDateFromStartDate();
      this.reviewerService.fetchReviewerAndUpdate();
    })
  }

  onPassSubmit(): void {
    if (this.passwordForm.invalid) {
      this.toastService.showError('Please complete all required fields');
      return;
    }

    const { currentPassword, newPassword, confirmPassword } = this.passwordForm.value;
    const refreshObject = {
      refreshToken: this.storageService.getCookieValueByKey('refreshToken'),
      expiryFor: 'web'
    };

    this.reviewerService.changePassword(currentPassword, newPassword, confirmPassword, refreshObject).subscribe(
      (response) => {
        this.toastService.showSuccess('Password changed successfully');
        this.passwordForm.reset();
        this.authService.logout()
      }
    );
  }

  getBool(flag:boolean|undefined): boolean{
    return Boolean(flag);
  }

  hasDateChange(status: boolean): void {
    this.isDateChange = status;
  }

  formatPhoneNo(): void {
    this.phone.partOne = this.reviewer.profile.contact.home.slice(0, 3);
    this.phone.partTwo = this.reviewer.profile.contact.home.slice(3, 6);
    this.phone.partThree = this.reviewer.profile.contact.home.slice(6, 10);
  }

  setEndDateFromStartDate(): void {
    const date = this.notificationPref.unAvailableStartDate || this.currentDate;
    this.minStartDate = date;
    this.maxStartDate = new Date();
    this.minEndDate = new Date(date.getTime());
    this.maxEndDate = new Date(date.getTime());
    this.maxEndDate.setDate(date.getDate() + 29);
  }

  updatePreference(type: string): void {
    const body: any = {};
    body[type] = this.notificationSwitches.value[type as keyof NotificationPreference];
    this.notificationPref = this.preparePreferenceForm();
    // Your validation logic
    if (!this.notificationPref.email && !this.notificationPref.notification && !this.notificationPref.sms) {
      this.notificationPref[type as keyof NotificationPreference] = !this.notificationPref[type as keyof NotificationPreference];
      this.toastService.showError('You must enable at least one notification option...');
    } else if (type === 'sms' && !this.reviewer.profile.contact.isPhoneVerified && this.notificationPref.sms) {
      this.notificationPref.sms = false;
      this.toastService.showError('Please verify your phone number to receive SMS notifications');
    } else if (type === 'unAvailableStatus' && this.notificationPref[type] && (!this.notificationPref.unAvailableStartDate || !this.notificationPref.unAvailableEndDate)) {
      this.toastService.showError('Please enter a data range to set your unavailability');
    } else {
      if (type === 'unAvailableStatus') {
        if (this.notificationPref[type as keyof NotificationPreference]) {
          body[type] = this.notificationPref[type];
          body.unAvailableStartDate = this.notificationPref.unAvailableStartDate.toISOString();
          body.unAvailableEndDate = this.notificationPref.unAvailableEndDate.toISOString();
          body.timezone = moment().utcOffset();
        } else {
          body[type] = false;
          this.notificationPref.unAvailableStartDate = null;
          this.notificationPref.unAvailableEndDate = null;
        }
      }
      this.reviewerService.updateNotificationPreference(body).subscribe(
        res => {
          this.toastService.showSuccess( res.message);
          this.initializeSettings();
        },
        err => {
          this.toastService.showError(err.data?.message || 'Error updating notification preferences.');
          this.notificationPref[type as keyof NotificationPreference] = !this.notificationPref[type as keyof NotificationPreference];
          if (type === 'unAvailableStatus') {
            this.notificationPref.unAvailableStartDate = null;
            this.notificationPref.unAvailableEndDate = null;
          }
        }
      );
    }
  }

  preparePreference(notificationPreference: NotificationPreference): any {
    let notObject = {...notificationPreference};
    notObject.unAvailableStartDate = notificationPreference.unAvailableStartDate ? new Date(notificationPreference.unAvailableStartDate) : null;
    notObject.unAvailableEndDate = notificationPreference.unAvailableEndDate ? new Date(notificationPreference.unAvailableEndDate) : null;
    return notObject;
  }
  preparePreferenceForm(): any {
    let notObject = {...this.notificationSwitches.value};
    notObject.unAvailableStatus = this.unAvailableForm.value.unAvailableStatus;
    notObject.unAvailableStartDate = this.unAvailableForm.value.startDate ? new Date(this.unAvailableForm.value.startDate) : null;
    notObject.unAvailableEndDate = this.unAvailableForm.value.endDate ? new Date(this.unAvailableForm.value.endDate ) : null;
    return notObject;
  }

  refreshPreferences(): void {
  //  this.reviewerService.fetchReviewerAndUpdate();
  }

  sendVerificationPhoneSms(): void {
    const phoneNo = this.tempPhone.partOne + this.tempPhone.partTwo + this.tempPhone.partThree;
    this.reviewerService.sendVerificationPhoneSms(phoneNo).subscribe(
      res => {
        this._isShowVerificationPhoneForm = true;
        this.toastService.showSuccess(res.data?.message || 'Verification code has been sent to your registered mobile number.');
      },
      err => {
        this.toastService.showError(err.data?.message || 'Error in phone number verification.');
      }
    );
  }

  editPhoneNo(): void {
    this.showEditPhoneForm = !this.showEditPhoneForm;
    this.editPhoneForm.setValue({
      partOne:this.reviewer.profile.contact.home.slice(0, 3),
      partTwo:this.reviewer.profile.contact.home.slice(3, 6),
      partThree:this.reviewer.profile.contact.home.slice(6, 10)
    });
    this.editPhoneForm.markAsPristine();
  }

  showVerificationPhoneForm(): void {
    this._isShowVerificationPhoneForm = !this._isShowVerificationPhoneForm;
    this.verificationPhoneForm.reset();
  }

  updatePhone(): void {
    if (this.editPhoneForm.valid) {
      const phoneNo = this.editPhoneForm.value.partOne + this.editPhoneForm.value.partTwo + this.editPhoneForm.value.partThree;
      this.reviewerService.updatePhoneNo({ phone: phoneNo }).subscribe(
        res => {
          this.toastService.showSuccess(res.data?.message || 'Phone number successfully updated.');
          this.editPhoneNo();
          this.initializeSettings();
          this.reviewerService.fetchReviewerAndUpdate();
        }
      );
    }
  }

  verifyPhone(): void {
    if (this.verificationPhoneForm.valid) {
      this.userService.verifyPhone({ code: this.verificationPhoneForm.value.verificationCode }).subscribe(
        res => {
          this.toastService.showSuccess(res.data?.message || 'Phone number successfully verified.');
          this.showVerificationPhoneForm();
          this.refreshPreferences();
        }
      );
    }
  }
  requestAccountDeletion() {
    this.confirmationDialogService.confirm({
    message: `You are about to deactivate your ${this.title}  account. You will no longer have access to the ${this.title}  platform or any of your records. Are you sure?`,
    header: 'Confirmation',
    icon: 'pi pi-exclamation-triangle',
    acceptIcon:"none",
    rejectIcon:"none",
    rejectButtonStyleClass:"p-button-text",
      accept: () => {
        
          this.reviewerService.requestForAccountDeletion().subscribe((response)=>{
            this.toastService.showSuccess('Request Initiated');
            this.authService.logout();
      });              
    }});
  }
    

  refreshProfileStrength(): void {
    // Your logic to refresh profile strength
  }

  formatContact(event: any): void {
    const formattedInput = this.helperService.formatPhone(event.target.value);
    event.target.value = formattedInput;

    const controlName = event.target.getAttribute('formcontrolname');
    if (controlName && this.profileForm) {
      this.profileForm.get(controlName)?.setValue(formattedInput, { emitEvent: false });
    }
  }

  showAppDownloadPopup(type: string): void {
    this.showAppDownloadModal = true;
    this.appUrl = type === 'ios' ? this.appStoreUrl : this.playStoreUrl;
  }

  getAvailablityTooltipContent(): string{
    return `Select a range of dates (up to 30 days) where you will be unavailable and do not want to receive project offers from ${environment.title}. You will not be eligible to receive offers during this time period. You can toggle this setting off at any time during the set time period if you wish to receive offers again.`
  }
}
